import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import UseStateContext from './session/UseStateContext'
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Success from './components/Success';
import Header from './components/Header';

const Manufacturer = () => {
    const { context, setContext } = UseStateContext();

    const [lead, setLead] = useState({});
    const [moreInformation, setMoreInformation] = useState("");

    let navigate = useNavigate();

    useEffect(() => {
        if (context.lead) {
            loadLead(context.lead);
        }
    }, [context.lead]);

    const loadLead = async (lead) => {
        setLead(lead);
    }

    const onSubmit = () => {
        let body = {
            ...lead,
            moreInformation: moreInformation
        };

        axios.post(`/Lead`, body).then(() => {
            setContext({ lead: lead });
            navigate("/success");
        });
    }

    let validation = true;

    return (
        <>
            <Navbar />
            <Banner />
            <div className='container mt-4 page-container'>
                <Header />

                <Success lead={lead} />

                <form>
                    <div className='content m-3 mb-4'>
                        <h3 className='text text-dark fw-semibold fs-5 mb-3'>Weitere Informationen</h3>
                        <p className='text text-secondary fs-6 mb-3'>Weitere Bedürfnisse des Kunden oder sonstige Informationen zur Anfrage</p>
                        <div className='mb-2'>
                            <div className="form-check mb-2 p-0">
                                <textarea
                                    className="form-control"
                                    placeholder="Bitte eingeben..."
                                    style={{ height: "100px" }}
                                    value={moreInformation}
                                    onChange={(e) => setMoreInformation(e.target.value)}
                                    maxLength="500"
                                />
                            </div>
                        </div>
                    </div>
                </form>

                <div className='row p-3 mb-5'>
                    <button className='lead-button col-12' onClick={onSubmit} disabled={!validation}>Lead absenden</button>
                </div>
            </div>
        </>
    )
}

export default Manufacturer